var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGamebg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "2760px",
    height: "2760px",
    viewBox: "0 0 460 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 240 0 L 220 0 230 230 240 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 279.75 5.25 L 260.05 1.8 230 230 279.75 5.25 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 318.05 17.3 L 299.25 10.45 230 230 318.05 17.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 353.65 35.85 L 336.3 25.85 230 230 353.65 35.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_4_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 385.5 60.25 L 370.15 47.4 230 230 385.5 60.25 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_5_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 412.6 89.85 L 399.75 74.5 230 230 412.6 89.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_6_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 434.15 123.7 L 424.15 106.35 230 230 434.15 123.7 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_7_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 449.5 160.75 L 442.7 141.95 230 230 449.5 160.75 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_8_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 458.2 199.95 L 454.75 180.25 230 230 458.2 199.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_9_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 460 240 L 460 220 230 230 460 240 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_10_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 454.75 279.8 L 458.2 260.1 230 230 454.75 279.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_11_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 442.7 318.1 L 449.5 299.3 230 230 442.7 318.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_12_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 424.15 353.7 L 434.15 336.35 230 230 424.15 353.7 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_13_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 399.75 385.5 L 412.6 370.2 230 230 399.75 385.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_14_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 370.15 412.65 L 385.5 399.8 230 230 370.15 412.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_15_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 336.3 434.2 L 353.65 424.2 230 230 336.3 434.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_16_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 299.25 449.55 L 318.05 442.75 230 230 299.25 449.55 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_17_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 260.05 458.25 L 279.75 454.8 230 230 260.05 458.25 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_18_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 220 460 L 240 460 230 230 220 460 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_19_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 180.2 454.8 L 199.9 458.25 230 230 180.2 454.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_20_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 141.9 442.75 L 160.7 449.55 230 230 141.9 442.75 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_21_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 106.3 424.2 L 123.65 434.2 230 230 106.3 424.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_22_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 74.5 399.8 L 89.8 412.65 230 230 74.5 399.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_23_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 47.35 370.2 L 60.2 385.5 230 230 47.35 370.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_24_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 25.8 336.35 L 35.8 353.7 230 230 25.8 336.35 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_25_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 10.4 299.3 L 17.25 318.1 230 230 10.4 299.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_26_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 1.75 260.1 L 5.2 279.8 230 230 1.75 260.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_27_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 0 220 L 0 240 230 230 0 220 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_28_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 230 230 L 5.2 180.25 1.75 199.95 230 230 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_29_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 17.25 141.95 L 10.4 160.75 230 230 17.25 141.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_30_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 35.8 106.35 L 25.8 123.7 230 230 35.8 106.35 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_31_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 60.2 74.5 L 47.35 89.85 230 230 60.2 74.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_32_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 89.8 47.4 L 74.5 60.25 230 230 89.8 47.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_33_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 123.65 25.85 L 106.3 35.85 230 230 123.65 25.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_34_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 160.7 10.45 L 141.9 17.3 230 230 160.7 10.45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_35_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    stroke: "none",
    d: " M 199.9 1.8 L 180.2 5.25 230 230 199.9 1.8 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_FILL"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_1_FILL"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_2_FILL"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_3_FILL"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_4_FILL"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_5_FILL"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_6_FILL"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_7_FILL"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_8_FILL"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_9_FILL"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_10_FILL"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_11_FILL"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_12_FILL"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_13_FILL"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_14_FILL"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_15_FILL"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_16_FILL"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_17_FILL"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_18_FILL"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_19_FILL"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_20_FILL"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_21_FILL"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_22_FILL"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_23_FILL"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_24_FILL"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_25_FILL"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_26_FILL"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_27_FILL"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_28_FILL"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_29_FILL"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_30_FILL"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_31_FILL"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_32_FILL"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_33_FILL"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_34_FILL"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_35_FILL"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamebg1);
export default __webpack_public_path__ + "static/media/gamebg1.0b38c3ca1efc5cd046e01701abf49430.svg";
export { ForwardRef as ReactComponent };